/**
 * nativeDateSupportCheck.js
 *
 * @description Adds check to see if browser natively supports date and time inputs.
 */

/**
 * Checks if a browser supports input[type=date] by trying to set an illegal value.
 *
 * @description If the browser falls back to a regular input, then the input won't be sanitized.
 * By checking the value after setting an invalid value, we can tell if there was sanitization or not.
 *
 * @export
 * @returns `true` or `false`, based on browser support.
 */
export function supportsDate () {
  let input = document.createElement('input')
  input.setAttribute('type', 'date')

  const invalidDate = 'not-a-date'
  input.setAttribute('value', invalidDate)

  return (input.value !== invalidDate)
}

/**
 * Checks if a browser supports input[type=time] by trying to set an illegal value.
 *
 * @description If the browser falls back to a regular input, then the input won't be sanitized.
 * By checking the value after setting an invalid value, we can tell if there was sanitization or not.
 *
 * @export
 * @returns `true` or `false`, based on browser support.
 */
export function supportsTime () {
  let input = document.createElement('input')
  input.setAttribute('type', 'time')

  const invalidDate = 'not:a:time'
  input.setAttribute('value', invalidDate)

  return (input.value !== invalidDate)
}
